import { FILE_TYPES } from '@/micros/homepage/content/utils/content-utils';
import { ContentState } from './types';

export const initialState: ContentState = {
  loadingContent: false,
  pageNumber: 1,
  sortBy: '',
  search: '',
  viewType: 'grid',
  contentMarkedForDeletion: {},
  selectedFileType: FILE_TYPES.ALL_DOCS,
  products: null,
  documents: null,
  contentTypeToAdd: null,
  recordings: null,
  uploadedVideos: null,
  pendingDownloads: null,
  projectsFilter: [],
  productAttributesFilter: [],
  uploadJobs: [],
  templates: null,
  fonts: null,
  themePacks: null,
  currentContent: [],
};
